<template id="centre-details">
  <div class="maxw">
    <h2>Detalls Centre</h2>
    <b-form>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Centre:" label-for="input-nombre">
            {{ centre.nombre }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Grup:">
            {{ this.grups.find(x => x.identifier === centre.grupoIdentifier).nombre }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Adreça:">
              {{ centre.dirección }}
          </b-form-group>
        </b-col>
        <b-col>
        <b-form-group label-class="font-weight-bold" label="CP:">
            {{ centre.cp }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Població:">
                {{ centre.poblacion }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Provincia:">
            {{ centre.provincia }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Telèfon:">
                {{ centre.telefono }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Horari:">
            {{ centre.horario }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Web:">
            {{ centre.url }}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-class="font-weight-bold" label="Activo:">
            {{ centre.isActive }}
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button class="mr-2" variant="outline-success" @click="$router.push({name: 'CentreEdit', params: { form: centre,  grups: grups },})">Editar</b-button>
          <b-button class="mr-2" variant="outline-danger" @click="$router.push({name: 'CentreDelete', params: { centre: centre , grups: grups},})">Esborrar</b-button>
          <b-button class="mr-2" variant="outline-primary"><router-link :to="{ name: 'Centres'}">Cancel</router-link></b-button>
        </b-col>
      </b-row>
      <b-form-input :hidden="true" type="text" v-model="centre.identifier"></b-form-input>
    </b-form>
  </div>
</template>

<script>
export default {
  props: {
    grups: {
      type: Array,
      required: true
    },
    centre: {
      identifier: null,
      nombre: null,
      horario: null,
      telefono: null,
      cp: null,
      poblacion: null,
      provincia: null,
      dirección: null,
      isActive: null,
      url: null,
      grupoIdentifier: null
    }
  }
}
</script>

<style scoped>
  .maxw {
    width: 80%;
    margin: 40px auto;
  }
</style>
